import {useCallback} from "react";
import useAPIService from "../../../hooks/useAPIService";

export const useApi = () => {
  const {apiFetch} = useAPIService();

  const fetchVideos = useCallback(async () => {
    try {
      const {result, data} = await apiFetch(`/get-videos`);
      if (result === "success") {
        data.sort((a, b) => a.id.localeCompare(b.id));
        return data;
      }
    } catch (err) {
      console.error(err);
    }
    return [];
  }, [apiFetch]);

  const fetchActivity = useCallback(
    async (contactId) => {
      try {
        const {result, data} = await apiFetch(`/get-contact/id/${contactId}`);
        if (result === "success") {
          if (data[0]?.activity) return data[0].activity;
        }
      } catch (err) {
        console.error(err);
      }
      return {};
    },
    [apiFetch],
  );

  const fetchWatchHistory = useCallback(
    async (contactId) => {
      try {
        const {result, data} = await apiFetch(`/get-contact/id/${contactId}`);
        if (result === "success") {
          if (data[0]?.watch_history) return data[0].watch_history;
        }
      } catch (err) {
        console.error(err);
      }
      return {};
    },
    [apiFetch],
  );

  const updateActivityAndHistory = useCallback(
    async ({user, activity, watchHistory, keepalive}) => {
      try {
        const {result, data} = await apiFetch(`/update-contact/activity`, {
          method: "PATCH",
          keepalive: keepalive,
          body: JSON.stringify({
            customer_id_u: user.customer_id,
            customer_firstname_u:
              user.firstname || user.given_name || "Unknown",
            customer_lastname_u: user.lastname || user.family_name || "Unknown",
            activity_u: activity || {},
            watch_history_u: watchHistory || {},
            timestamp_u: new Date().toISOString(),
          }),
        });
        if (result === "success") {
          return data;
        }
      } catch (err) {
        console.error(err);
      }
      return {};
    },
    [apiFetch],
  );

  return {
    fetchVideos,
    fetchActivity,
    fetchWatchHistory,
    updateActivityAndHistory,
  };
};
